<template>
	<div>
		<el-container class="navpage">
			<el-main style="padding: 0 10px;">
				<el-button type="warning" size="mini" icon="el-icon-edit" @click="addBbs('')">添加留言模板</el-button>
				<el-button-group>
					<el-button type="primary" size="mini" icon="el-icon-select" @click="selectAll">全选</el-button>
					<el-button type="warning" size="mini" icon="el-icon-select" @click="selectDiff">反选</el-button>
				</el-button-group>
				<el-dropdown trigger="click">
					<el-button type="primary" icon="el-icon-setting" size="mini">
						筛选
						<i class="el-icon-arrow-down el-icon--right"></i>
					</el-button>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item v-for="(items, index) in filtrateList" :key="index">
							<el-dropdown trigger="hover" placement="right-start" @command="seleCommand">
								<el-button type="text" icon="el-icon-caret-right" size="mini">{{ items.label }}</el-button>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item
										icon="el-icon-caret-right"
										v-for="(item, key) in items.seconds"
										:key="key"
										:command="{ indexa: index, indexb: key, param: items.paramValue, paramval: item.val }"
										:class="item.checked ? 'color-blue' : ''"
									>
										{{ item.label }}
									</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
				<el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteBbs">删除</el-button>
				<el-button type="warning" size="mini" icon="el-icon-refresh" @click="getList()">刷新</el-button>
				<el-dropdown trigger="click">
					<el-button type="success" icon="el-icon-setting" size="mini">
						设置
						<i class="el-icon-arrow-down el-icon--right"></i>
					</el-button>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item v-for="(items, index) in setList" :key="index">
							<el-dropdown trigger="hover" placement="right-start" @command="setCommand">
								<el-button type="text" icon="el-icon-caret-right" size="mini">{{ items.label }}</el-button>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item
										icon="el-icon-caret-right"
										v-for="(item, index) in items.seconds"
										:key="index"
										:command="{ setParam: items.paramValue, setParamVal: item.val }"
									>
										{{ item.label }}
									</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
				<el-table
					:data="bbsList"
					style="width: 100%;margin-bottom: 20px;"
					row-key="did"
					:stripe="true"
					:default-sort="{ prop: 'bid', order: 'descending' }"
					@sort-change="sortChange"
					@selection-change="selectChange"
					tooltip-effect="dark"
					ref="multipleTable"
				>
					<el-table-column type="selection" width="55"></el-table-column>
					<el-table-column prop="bid" label="序号" width="80" sortable></el-table-column>
					<el-table-column prop="bbsname" label="留言板名称" show-overflow-tooltip align="center"></el-table-column>
					<el-table-column prop="num" label="留言数量" >
						<template slot-scope="scope">
							{{messageNum[scope.row.bid]?messageNum[scope.row.bid].num:0}}
						</template>
					</el-table-column>
					<el-table-column prop="isclass" label="启用状态" width="100">
						<template slot-scope="scope">
							<i :class="scope.row.isclass ? 'el-icon-unlock color-green' : 'el-icon-lock color-red'"></i>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="280">
						<template slot-scope="scope">
							<el-button type="primary" size="mini" @click="infoList(scope.row)">留言列表</el-button>
							<el-button type="success" size="mini" @click="changebbsAttr(scope.row)">字段管理</el-button>
							<el-button type="warning" size="mini" @click="addBbs(scope.row)">修改</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div class="block">
					<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:current-page="thispage"
						:page-sizes="pageSizes"
						:page-size="pagesize"
						layout="total, sizes, prev, pager, next, jumper"
						:total="total"
					></el-pagination>
				</div>
				
				<!-- 添加留言板 -->
				<el-dialog title="添加留言模板" :visible.sync="dialogVisible" width="80%" :close-on-click-modal="false">
					<el-form class="text-left" ref="attrForm" :rules="rules" :model="addBbsScope">
						<el-form-item label="留言模板名称" :label-width="formLabelWidth" prop="bbsname">
							<el-input v-model="addBbsScope.bbsname" autocomplete="off" placeholder="请输入留言模板名称,2-50个字符"></el-input>
						</el-form-item>
						<el-form-item label="绑定表" :label-width="formLabelWidth" prop="bbsname">
							<el-input v-model="addBbsScope.bindsql" autocomplete="off" placeholder="默认网站留言表,可不填"></el-input>
						</el-form-item>
						<el-form-item label="留言提交间隔" :label-width="formLabelWidth" prop="delay">
							<el-input v-model="addBbsScope.delay" autocomplete="off" placeholder="请输入留言提交间隔,秒数计,选填"></el-input>
						</el-form-item>
						<el-form-item label="提交成功反馈" :label-width="formLabelWidth" prop="successback">
							<el-input v-model="addBbsScope.successback" autocomplete="off" placeholder="请输入提交成功反馈,2-200个任意字符"></el-input>
						</el-form-item>
					</el-form>
					<div slot="footer" class="dialog-footer">
						<el-button @click="dialogVisible = false">取 消</el-button>
						<el-button type="primary" @click="submitRuleForm('attrForm')">确 定</el-button>
					</div>
				</el-dialog>
				
			</el-main>
		</el-container>
	</div>
</template>
<script>
export default {
	name: '',
	data() {
		return {
			bbsList:[],
			messageNum:[],
			thispage: 1,
			total: 0,
			pagesize: 10, //每页显示条数
			pageSizes: [10, 15, 20, 30], //每页显示个数选择器
			sort_param: 'bid', //排序字段
			sort_type: 'desc', //排序方式ascending = asc;descending = desc,'' = asc;
			selectedBbsIds: [],
			filtrateList: [
				{
					label: '启用状态',
					paramValue: 'isclass',
					seconds: [
						{
							val: '',
							label: '全部',
							checked: true
						},
						{
							val: 1,
							label: '开启'
						},
						{
							val: 0,
							label: '关闭'
						}
					]
				}
			],
			setList: [
				{
					label: '启用状态',
					paramValue: 'isclass',
					seconds: [
						{
							val: 1,
							label: '开启'
						},
						{
							val: 0,
							label: '关闭'
						}
					]
				}
			],
			setParam: '',
			setParamVal: '',
			selectParams:[],
			dialogVisible: false,
			formLabelWidth: '120px',
			addBbsScope:{
				bbsname:'',
				delay:'',
				successback:'',
				bindsql:''
			},
			rules: {
				bbsname: [{ required: true, message: '请输入留言模板名称', trigger: 'blur' }, { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }],
				successback: [{ required: true, message: '请输入留言提交成功反馈', trigger: 'blur' }, { min: 2, max: 200, message: '长度在 2 到 200 个字符', trigger: 'blur' }],
			},
		};
	},
	mounted() {
		this.getList(true);
	},
	methods: {
		handleSizeChange(val) {
			// console.log(`每页 ${val} 条`);
			this.pagesize = val;
			this.getList();
		},
		handleCurrentChange(val) {
			// console.log(`当前页: ${val}`);
			this.thispage = val;
			this.getList();
		},
		getList(firstLoad = false) {
			let separ = [];
			for (let i in this.selectParams) {
				console.log(i, this.selectParams[i]);
				separ.push({ param: i, paramVal: this.selectParams[i] });
			}
			this.$axios({
				url: this.HOST + '/admin.module/BBSModuleList',
				method: 'post',
				data: {
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token,
					thispage:this.thispage,
					pagesize:this.pagesize,
					sort_param:this.sort_param,
					sort_type:this.sort_type,
					selectParams:separ,
					firstLoad:firstLoad
				}
			})
				.then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						if (res.data.admin_err == 'admininfo_error') {
							this.$message.error(res.data.msg);
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.bbsList = res.data.data;
						this.total = res.data.total;
						if(firstLoad){
							this.messageNum = res.data.messageNum;
						}
					}
				})
				.catch(err => {});
		},
		sortChange({ column, prop, order }) {
			console.log(column, prop, order);
			this.sort_param = prop;
			this.sort_type = order == 'descending' ? 'desc' : 'asc';
		},
		selectChange(selection) {
			console.log(selection);
			let arr = [];
			for (let i in selection) {
				arr.push(selection[i].bid);
			}
			this.selectedBbsIds = arr;
			console.log(this.selectedBbsIds);
		},
		changebbsAttr(scope){
			this.$router.push({path:'/bbsModule/bbsAttr',query:{'bid':scope.bid,'bbsname':scope.bbsname}});
		},
		infoList(scope){
			this.$router.push({path:'/bbsModule/messageList',query:{'bid':scope.bid,'bbsname':scope.bbsname}});
		},
		// 全选
		selectAll() {
			this.bbsList.map(item => {
				this.$refs.multipleTable.toggleRowSelection(item, true); //切换该子节点选中状态
			});
			// this.selectedBbsIds = this.docIds;
		},
		// 反选
		selectDiff() {
			let diff = [];
			this.bbsList.map(item => {
				if (this.selectedBbsIds.indexOf(item.bid) != -1) {
					this.$refs.multipleTable.toggleRowSelection(item, false); //切换该子节点选中状态
				} else {
					diff.push(item.bid);
					this.$refs.multipleTable.toggleRowSelection(item, true); //切换该子节点选中状态
				}
			});
			this.selectedBbsIds = diff;
			console.log(this.selectedBbsIds);
		},
		deleteBbs() {
			if (!this.selectedBbsIds.length) {
				this.$message.error('尚未选中任何模型！');
				return false;
			}
			this.$confirm('是否要删除所选模型？一经删除不可恢复！')
				.then(() => {
					this.$axios({
						url: this.HOST + '/admin.module/deleteBbs',
						method: 'post',
						data: {
							adminid: JSON.parse(this.$store.state.user.userInfo).id,
							token: JSON.parse(this.$store.state.user.userInfo).token,
							bbsIds: this.selectedBbsIds
						}
					})
						.then(res => {
							console.log(res.data);
							if (res.data.status == 0) {
								this.$message.error(res.data.msg);
								if (res.data.admin_err == 'admininfo_error') {
									this.exit().then(res => {
										console.log(res);
										if (res.actionStatus == 1) {
											this.$router.push('/login');
										}
									});
								}
							} else {
								this.$message.success(res.data.msg);
								this.getList();
							}
						})
						.catch(err => {});
				})
				.catch(() => {});
		},
		seleCommand(command) {
			console.log('sele:', command);
			this.selectParams[command.param] = command.paramval;
			this.filtrateList[command.indexa].seconds.map(item => {
				this.$set(item, 'checked', false);
			});
			this.filtrateList[command.indexa].seconds[command.indexb].checked = true;
			console.log(this.selectParams);
			this.getList();
		},
		setCommand(command) {
			console.log('set:', command);
			this.setParam = command.setParam;
			this.setParamVal = command.setParamVal;
			this.setBbsParam();
		},
		setBbsParam() {
			if (!this.selectedBbsIds.length) {
				this.$message.error('尚未选中任何内容');
				return false;
			}
			this.$axios({
				url: this.HOST + '/admin.module/setBbsParam',
				method: 'post',
				data: {
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token,
					bbsIds: this.selectedBbsIds,
					setParam: this.setParam,
					setParamVal: this.setParamVal
				}
			})
				.then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						if (res.data.admin_err == 'admininfo_error') {
							this.$message.error(res.data.msg);
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.bbsList.map(item => {
							if (this.selectedBbsIds.indexOf(item.bid) !== -1) {
								item[this.setParam] = this.setParamVal;
							}
						});
						this.$message.success(res.data.msg);
						// this.selectedBbsIds = []//选中值初始化
					}
				})
				.catch(err => {});
		},
		addBbs(scope){
			if(!scope){
				this.addBbsScope = {
					bbsname:'',
					bindsql:''
				}
			}else{
				this.addBbsScope = JSON.parse(JSON.stringify(scope));
			}
			this.dialogVisible = true;
		},
		submitRuleForm(formname) {
			this.$refs[formname].validate((valid, attr) => {
				if (valid) {
					this.addSubmit();
				} else {
					console.log('error submit!!', attr);
					return false;
				}
			});
		},
		addSubmit() {
			this.$confirm('确定提交？')
				.then(() => {
					this.$axios({
						url: this.HOST + '/admin.module/addBbs',
						method: 'post',
						data: {
							adminid: JSON.parse(this.$store.state.user.userInfo).id,
							token: JSON.parse(this.$store.state.user.userInfo).token,
							bbsInfo: this.addBbsScope
						}
					})
						.then(res => {
							console.log(res.data);
							if (res.data.status == 0) {
								this.$message.error(res.data.msg);
								if (res.data.admin_err == 'admininfo_error') {
									this.exit().then(res => {
										console.log(res);
										if (res.actionStatus == 1) {
											this.$router.push('/login');
										}
									});
								}
							} else {
								this.dialogVisible = false;
								this.$message.success(res.data.msg);
								this.thispage = 1;
								this.getList();
							}
						})
						.catch(err => {});
				})
				.catch(() => {
					console.log('取消');
				});
		}
	}
};
</script>
<style lang="scss">
.el-main {
	padding: 0;
	.navpage {
		min-height: calc(100vh - 161px);
		.aside-primary {
			width: 240px;
			height: 100%;
			background-color: #ecf5ff;
			// height: 100%;
			padding: 20px;
			.el-divider__text {
				background-color: #ecf5ff;
				padding: 0 2px;
				font-size: 13px;
			}
			.el-menu-parent {
				background-color: transparent;
				.el-submenu {
					margin-bottom: 10px;
					background-color: #fff;
				}
				.el-menu-item {
					height: 45px;
					line-height: 45px;
					margin-bottom: 10px;
					background-color: #fff;
					min-width: 180px;
				}
			}
		}
		.width240 {
			width: 240px !important;
			transition: 0.8s;
		}
		.width0 {
			width: 0 !important;
		}
		.color-green {
			color: green;
		}
		.color-red {
			color: #ff2f4b;
		}
		.el-dropdown{
			margin: 0 10px;
		}
		.el-button + .el-button-group {
			margin-left: 10px;
		}
	}
}
</style>
